import Stack from '@mui/material/Stack';
import { JSONSchema7 } from 'json-schema';
import { useContext, useRef } from 'react';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';
import { get } from '../../Shared/ajax';
import styles from './ControlAttachment.module.css';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);
  const { versionExternalId, isReadOnlyView } = state;

  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const dataSchema = properties['data'] as JSONSchema7;
  const externalIdSchema = properties['externalId'] as JSONSchema7;
  const displayNameSchema = properties['displayName'] as JSONSchema7;
  const fileNameSchema = properties['filename'] as JSONSchema7;

  const label = labelSchema.default as string;
  const attachmentDataURL =
    (dataSchema.default as string) || (externalIdSchema.default as string);
  const displayName = displayNameSchema.default as string;
  const fileName = fileNameSchema.default as string;

  const controlWrapperRef = useRef<HTMLDivElement | null>(null);

  const downloadLinkLabel = displayName ? displayName : fileName;

  const nav = window.navigator as any;

  const downloadPdf = async () => {
    const response = await get<Blob>(
      'DynamicWorkflowVersion/' +
        versionExternalId +
        '/Attachment/' +
        attachmentDataURL,
      'blob'
    );

    if (nav && nav.msSaveOrOpenBlob) {
      // For IE11
      nav.msSaveOrOpenBlob(response, fileName);
    } else {
      // Modern browsers
      const fileUrl = window.URL.createObjectURL(response);
      window.open(fileUrl);
    }
  };

  return (
    <Stack ref={controlWrapperRef}>
      {label && <h4>{label}</h4>}
      <button
        className={styles.customControlAttachmentButtonStyle}
        onClick={downloadPdf}
      >
        {downloadLinkLabel}
      </button>
    </Stack>
  );
};
